import React, { useMemo } from "react";

// import BlogItem from "./item";

import { Col, CardHeader } from "reactstrap";
import Theme from "../../theme";
import { useRequestProcessor } from "../../requestProcessor";
import BlogItem from "./BlogItem";
import SpinnerLoading from "../../Components/utils/SpinnerLoading";
import { fetchBlogs } from "../../QueryFunctions/queryfunction";
import { StyledCard, StyledHeader, StyledParentContainer } from "./style";
import { useAtom } from "jotai";

import { blogAtom, mobileAtom } from "../../AtomStore/store";

const MobileBlogs = () => {
  const [blog, setBlog] = useAtom(blogAtom);

  const { useQueryWrapper } = useRequestProcessor();
  const { isLoading } = useQueryWrapper("blogs", fetchBlogs, {
    onSuccess: (blogs) => {
      const shuffleblog = [...blogs];

      if (Array.isArray(shuffleblog) && shuffleblog.length > 0) {
        for (let i = shuffleblog.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [shuffleblog[i], shuffleblog[j]] = [shuffleblog[j], shuffleblog[i]];
        }
        setBlog(shuffleblog);
      }
    },
  });

  useMemo(() => {
    console.log(`[Blogs] Fetching Blogs...`);
  }, []);

  if (isLoading) {
    return <SpinnerLoading />;
  }

  return (
    <StyledParentContainer>
      <StyledCard>
        <div className="p-2 flex flex-wrap gap-5 justify-around mt-3">
          {blog?.map((item, index) => (
            <BlogItem key={index} item={item} />
          ))}
        </div>
      </StyledCard>
    </StyledParentContainer>
  );
};

export default MobileBlogs;
